import type { PostDraft } from "./model";

/**
 * The review's revision: a number that is the same for the same posted content and different for different content. A go-ahead
 * names it, so it matches only the page that was reviewed, whether the content changed with Review open or closed, was undone
 * back, or came back from a reload (a counter would start again at 0 and could match an old go-ahead). What the manager has
 * only opened or touched does not change it.
 */
export const revisionOf = (draft: Pick<PostDraft, "shifts" | "po_number">) => {
  const text = JSON.stringify([draft.shifts, draft.po_number ?? ""], (key, value) =>
    key === "touched" || key === "hand_set" || key === "defaults" ? undefined : value,
  );
  let hash = 5381;
  // oxlint-disable-next-line unicorn/prefer-math-trunc -- bit-flag or hash arithmetic; `| 0` wraps to int32, Math.trunc does not
  for (let index = 0; index < text.length; index++) hash = (Math.imul(hash, 33) + (text.codePointAt(index) ?? 0)) | 0;
  return hash & 0x7fffffff;
};
